import React, { memo, useEffect, useState } from 'react';
import styles from './ForumList.module.less';
import ForumLineNoTag from '../../components/Forum/ForumLine/ForumLineNoTag';
import { useDispatch, useSelector } from 'react-redux';
import { getAppForumRelated } from '../../actions/detail';
import { createSelector } from 'reselect';
import { getForumList } from '../../actions/forum';
import { CONTEXT } from '../../config';
import { useHistory } from 'react-router';
import { logging, logPostInfo } from '../../actions/log';

const selectDetails = createSelector(
  state => state.detail,
  detail => ({
    forumRelated: detail.forumRelated,
  }),
);
const selectHotForum = createSelector(
  state => state.forum,
  forum => ({
    forumHot: (forum.forumList && forum.forumList.forumContentList) || [],
  }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ appDetailsData, activeTab }) => {
  const { forumRelated } = useSelector(selectDetails);
  const { forumHot } = useSelector(selectHotForum);
  const dispatch = useDispatch();
  const [hotForumList, setHotForumList] = useState([]);
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);

  useEffect(() => {
    if (!forumHot || forumHot.length === 0) {
      dispatch(getForumList({ refresh: true }));
    }
  }, [appDetailsData]);
  useEffect(() => {
    const tempList = forumHot.filter(item => {
      const forumRelatedList =
        (forumRelated && forumRelated.softId === appDetailsData.softID && forumRelated.forumList) ||
        [];
      const index = forumRelatedList.findIndex(relatedForum => relatedForum.id === item.id);
      return index < 0;
    });
    setHotForumList(tempList);
  }, [forumHot, appDetailsData, forumRelated]);
  const getForumRelated = () => {
    if (forumRelated.softId !== appDetailsData.softID) {
      dispatch(
        getAppForumRelated({
          softId: appDetailsData.softID,
          skip: 0,
          limit: 24,
        }),
      );
    }
  };
  useEffect(() => {
    getForumRelated();
  }, [appDetailsData]);

  const handleForum = type => () => {
    dispatch(
      logging({
        category: 'C',
        action: type === 'hot' ? 'AppDetail_Forum_More' : 'AppDetail_Go_Forum',
        label: '',
        param2: {
          source: 'AppDetail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          softid: appDetailsData.softID,
          softType: '0',
        },
      }),
    );
    dispatch(
      logPostInfo({
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
    history.push(`${CONTEXT}/forumlist`);
  };

  if (activeTab !== 'forum') {
    return null;
  }

  return (
    <div className={styles.forum}>
      <div className={styles.relase_forum}>
        <div className={styles.relase_forum_title}>
          <i className={`iconfont icon-release_forum ${styles.icon}`} />
          <div>相关帖子</div>
        </div>

        {forumRelated.softId === appDetailsData.softID &&
          (!forumRelated.forumList || forumRelated.forumList.length < 1) && (
            <div className={styles.release_forum_default} onClick={handleForum()}>
              还没有人对 {appDetailsData.softName} 分享或提问，<span> 点击前往论坛 </span>
              成为发帖第一人~
            </div>
          )}
        {forumRelated.softId === appDetailsData.softID &&
          forumRelated &&
          forumRelated.forumList &&
          forumRelated.forumList.length > 0 && (
            <div className={styles.relase_forum_list}>
              {forumRelated.forumList.slice(0, 3).map((forum, index) => (
                <ForumLineNoTag
                  forumData={forum}
                  logInfo={{ action: 'AppDetail_Forum', source: 'AppDetail', type: 'reco' }}
                  key={index}
                  softData={appDetailsData}
                />
              ))}
            </div>
          )}
      </div>
      {hotForumList && hotForumList.length > 0 && (
        <div className={styles.hot_forum}>
          <div className={styles.hot_forum_title}>
            <i className={`iconfont icon-hot_forum ${styles.icon}`} />
            <div>更多热议</div>
            <div className={styles.hot_forum_more} onClick={handleForum('hot')}>
              查看更多
            </div>
          </div>
          <div className={styles.hot_forum_list}>
            {hotForumList.slice(0, 10).map((forum, index) => (
              <ForumLineNoTag
                forumData={forum}
                logInfo={{ action: 'AppDetail_Forum', source: 'AppDetail', type: 'hot' }}
                key={index}
                softData={appDetailsData}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
});
